
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad-studio/ads",
      function () {
        return require("private-next-pages/ad-studio/ads.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ad-studio/ads"])
      });
    }
  